var NavItems = /*#__PURE__*/function (NavItems) {
  NavItems["Samples"] = "samples";
  NavItems["Plugins"] = "plugins";
  NavItems["Mastering"] = "mastering";
  NavItems["Distribution"] = "distribution";
  NavItems["Pricing"] = "pricing";
  return NavItems;
}({});

export { NavItems };
